export function downloadText(fileData: string | string[], fileName: string) {
    const convertedFileData = Array.isArray(fileData) ? fileData.join("\n") : fileData;
    const blob = new Blob([convertedFileData], { type: "text/plain" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.download = `${fileName}.txt`;
    link.href = url;
    link.click();
}